import styled from "styled-components";

export const TILE_SIZE = 228;

export const Tile = styled.div`
  background: #fefefe;
  border-radius: 6px;
  border: 1px solid #bdbdbd;
  display: flex;
  flex-direction: row;
  height: ${TILE_SIZE}px;
  width: ${({ hasThumbnail }) => (hasThumbnail ? TILE_SIZE * 2 : (TILE_SIZE-6))}px;
  cursor: ${({ isClickable }) => isClickable ? "pointer": "inherit"};
  color: #828282;
  overflow: hidden;
`;

export const Header = styled.div`
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #bdbdbd;
`;

export const Thumbnail = styled.img``;

export const Title = styled.div`
  font-weight: bold;
  color: #333333;
`;

export const Metadata = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
`;

export const Category = styled.div`
  color: #333333;
`;

export const Tier = styled.div``;
export const Date = styled.div``;
export const Result = styled.div`
  margin-top: 20px;
`;

export const MedalWrapper = styled.div`
  flex-grow: 2;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;
